export default __webpack_public_path__ + "static/media/Scope-5.4a66ff05.png";